import { Copy } from '../copy/Copy';

export const CONTACT_INIT_VALUES = {
  name: '',
  email: '',
  phone: '',
  interest: '',
  pvg: '',
  child: '',
  class: '',
};

export const INTEREST_SELECT_OPTIONS = [
  {
    label: Copy.generate('Volunteer.interest.pta'),
    value: 'JOIN PTA',
  },
  {
    label: Copy.generate('Volunteer.interest.volunteer'),
    value: 'VOLUNTEER AT PTA EVENTS',
  },
  {
    label: Copy.generate('Volunteer.interest.both'),
    value: 'JOIN PARENT COUNCIL',
  },
];

export const PVG_SELECT_OPTIONS = [
  {
    label: Copy.generate('Global.yes'),
    value: 'YES',
  },
  {
    label: Copy.generate('Global.no'),
    value: 'NO',
  },
];
